export const $getIcon = (type?: IconType): IconName => {
    if (!type) {
        return 'heroicons:question-mark-circle'
    }
    return iconTypes[type] ?? 'heroicons:question-mark-circle'
}

const iconVisualTypes: IconTypes = {
    // new names by icon look

    // solid icons, primarily because they use only lines of same thickness
    'arrow-path': 'heroicons:arrow-path-20-solid',
    'arrow-left': 'heroicons:arrow-small-left-20-solid',
    'arrow-left-on-rectangle': 'heroicons:arrow-left-on-rectangle-20-solid',
    'arrow-right': 'heroicons:arrow-small-right-20-solid',
    'arrow-right-end-on-rectangle': 'heroicons:arrow-right-end-on-rectangle-20-solid',
    'arrow-top-right-on-square': 'heroicons:arrow-top-right-on-square-20-solid',
    'arrows-right-left': 'heroicons:arrows-right-left-20-solid',
    'bars': 'heroicons:bars-3-20-solid',
    'check': 'heroicons:check-20-solid',
    'check-circle': 'heroicons:check-circle-20-solid',
    'chevron-double-left': 'heroicons:chevron-double-left-20-solid',
    'chevron-double-right': 'heroicons:chevron-double-right-20-solid',
    'chevron-down': 'heroicons:chevron-down-20-solid',
    'chevron-left': 'heroicons:chevron-left-20-solid',
    'chevron-right': 'heroicons:chevron-right-20-solid',
    'chevron-up': 'heroicons:chevron-up-20-solid',
    'chevron-up-down': 'heroicons:chevron-up-down-20-solid',
    'ellipsis-vertical': 'heroicons:ellipsis-vertical-20-solid',
    'ellipsis-horizontal': 'heroicons:ellipsis-horizontal-20-solid',
    'google-maps': 'mdi:google-maps',
    'link': 'heroicons:link-20-solid',
    'minus': 'heroicons:minus-20-solid',
    'plus': 'heroicons:plus-20-solid',
    'shield-check': 'heroicons:shield-check-20-solid',
    'x-circle': 'heroicons:x-circle-20-solid',
    'x-mark': 'heroicons:x-mark-20-solid',

    // outline icons
    'arrow-path-rounded-square': 'heroicons:arrow-path-rounded-square',
    'bell': 'heroicons:bell',
    'bug-ant': 'heroicons:bug-ant',
    'calendar': 'heroicons:calendar',
    'camera': 'heroicons:camera',
    'clipboard': 'heroicons:clipboard-document-list',
    'clock': 'heroicons:clock',
    'credit-card': 'heroicons:credit-card',
    'document-arrow-up': 'heroicons:document-arrow-up',
    'document-arrow-down': 'heroicons:document-arrow-down',
    'envelope': 'heroicons:envelope',
    'exclamation-circle': 'heroicons:exclamation-circle',
    'exclamation-triangle': 'heroicons:exclamation-triangle',
    'eye': 'heroicons:eye',
    'eye-slash': 'heroicons:eye-slash',
    'funnel': 'heroicons:funnel',
    'gift': 'heroicons:gift',
    'home': 'heroicons:home',
    'inbox': 'heroicons:inbox',
    'information-circle': 'heroicons:information-circle',
    'magnifying-glass': 'heroicons:magnifying-glass',
    'moon': 'heroicons:moon',
    'pencil': 'heroicons:pencil',
    'pencil-square': 'heroicons:pencil-square',
    'pin': 'mdi:pin-outline',
    'question-mark-circle': 'heroicons:question-mark-circle',
    'content-save-outline': 'mdi:content-save-outline',
    'signal': 'heroicons:signal',
    'signal-slash': 'heroicons:signal-slash',
    'soccer': 'mdi:soccer',
    'squares-plus': 'heroicons:squares-plus',
    'sun': 'heroicons:sun',
    'trash': 'heroicons:trash',
    'user': 'heroicons:user',
    'users': 'heroicons:users',
    'user-circle': 'heroicons:user-circle',
    'user-plus': 'heroicons:user-plus',
    'person': 'heroicons:user',
    'persons': 'heroicons:users',
    'person-circle': 'heroicons:user-circle',
    'person-plus': 'heroicons:user-plus',
    'phone': 'heroicons:phone',
    'variable': 'heroicons:variable',
    'whistle': 'mdi:whistle-outline',
    'wrench': 'heroicons:wrench',

    // currency icons
    'currency-dollar': 'ph:currency-dollar-bold',
    'currency-eur': 'ph:currency-eur-bold',
    'currency-gbp': 'ph:currency-gbp-bold',
    'currency-jpy': 'ph:currency-jpy-bold',

    // module icons
    'building-office': 'heroicons:building-office-2',
    'cpu-chip': 'heroicons:cpu-chip',
    'cog': 'heroicons:cog-6-tooth',
    'user-group': 'heroicons:user-group',
    'venues': 'heroicons:home-modern',
    'cup': 'bi:cup-hot',
    'globe': 'heroicons:globe-alt',

    // sports
    'fussball': 'mdi:soccer',
    'handball': 'mdi:soccer',
    'indiaca': '',
    'volleyball': 'mdi:volleyball',

    // icons not relevant for project
    'sparkles': 'heroicons:sparkles',
    'lock-closed': 'heroicons:lock-closed',
    'lock-open': 'heroicons:lock-open',
    'smile': 'heroicons:face-smile',
    'hand-thumb-up': 'heroicons:hand-thumb-up',
    'rocket-launch': 'heroicons:rocket-launch',
    'puzzle-piece': 'heroicons:puzzle-piece',
}


export const iconTypes: IconTypes = {
    ...iconVisualTypes,

    // old names by usage, deprecated

    // crud
    add: iconVisualTypes['plus'] as string,
    edit: iconVisualTypes['pencil'] as string,
    delete: iconVisualTypes['trash'] as string,
    clear: iconVisualTypes['x-circle'] as string,

    // basics
    check: iconVisualTypes['check'] as string,
    none: iconVisualTypes['question-mark-circle'] as string,
    hint: iconVisualTypes['question-mark-circle'] as string,
    success: iconVisualTypes['check-circle'] as string,
    secure: iconVisualTypes['shield-check'] as string,
    info: iconVisualTypes['information-circle'] as string,
    warning: iconVisualTypes['exclamation-circle'] as string,
    error: iconVisualTypes['exclamation-triangle'] as string,

    // actions
    close: iconVisualTypes['x-mark'] as string,
    refresh: iconVisualTypes['arrow-path'] as string,
    filter: iconVisualTypes['funnel'] as string,
    search: iconVisualTypes['magnifying-glass'] as string,
    tool: iconVisualTypes['wrench'] as string,
    filtered: iconVisualTypes['funnel'] as string,
    logout: iconVisualTypes['arrow-left-on-rectangle'] as string,
    login: iconVisualTypes['arrow-right-end-on-rectangle'] as string,
    downloadDocument: iconVisualTypes['document-arrow-down'] as string,
    save: iconVisualTypes['content-save-outline'] as string,

    // direction
    backwards: iconVisualTypes['chevron-double-left'] as string,
    left: iconVisualTypes['chevron-left'] as string,
    right: iconVisualTypes['chevron-right'] as string,
    up: iconVisualTypes['chevron-up'] as string,
    down: iconVisualTypes['chevron-down'] as string,
    forwards: iconVisualTypes['chevron-double-right'] as string,
    from: iconVisualTypes['arrow-small-left'] as string,
    to: iconVisualTypes['arrow-small-right'] as string,

    // ui
    dropdown: iconVisualTypes['chevron-up-down'] as string,
    menu: iconVisualTypes['ellipsis-vertical'] as string,
    bars: iconVisualTypes['bars'] as string,
    calendar: iconVisualTypes['calendar'] as string,
    pin: iconVisualTypes['pin'] as string,
    unlocked: iconVisualTypes['lock-open'] as string,
    locked: iconVisualTypes['lock-closed'] as string,
    link: iconVisualTypes['link'] as string,

    // misc
    user: iconVisualTypes['user'] as string,
    profile: iconVisualTypes['user-circle'] as string,
    cup: iconVisualTypes['cup'] as string,
    contactPersons: iconVisualTypes['user-group'] as string,
    venues: iconVisualTypes['venues'] as string,
    comment: iconVisualTypes['pencil-square'] as string,
    goal: iconVisualTypes['soccer'] as string,
}
